import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=24e61be4&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e61be4')) {
      api.createRecord('24e61be4', component.options)
    } else {
      api.reload('24e61be4', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=24e61be4&", function () {
      api.rerender('24e61be4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/Profile.vue"
export default component.exports